// packages/world-model/src/traits/edible/index.ts

export * from './edibleTrait';
export * from './edibleBehavior';